/**
 * Used for sending analytics events
 */
export function sendAnalyticsEvent(eventName: string, parameters?: unknown) {
  if (!gtag) {
    console.error('Google Analytics not initialized!');
  }
  gtag('event', eventName, parameters);
}
